import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { map } from "rxjs/operators";
import { Controller } from "../interface/controller.interface";
import { HTTPMethod } from "../model/http-method.enum";
import { HTTPRequestBuilder } from "../model/http.request.model";
import { orElse } from "../model/operator/or-else.operator";
import { CampaignLevel } from "../persistence/dto/campaign-level.model";
import { LevelTypeId } from "../persistence/dto/level-type-id.enum";
import { Task } from "../persistence/dto/task.model";
import { HTTPService } from "./http.service";

	/**
	 * @description
	 *  Servicio reflejo del controlador de nivel de campañas del backend.
	 *
	 * @see gigot-backend/Controllers/Sales/CampaignLevelsController.cs
	 */

@Injectable({ providedIn: "root" })
export class CampaignLevelService implements Controller {

    constructor(private httpService: HTTPService) {}

    public allZones(): Observable<string[]> {
        return this.httpService.send<typeof undefined, string[]>(
            new HTTPRequestBuilder()
                .method(HTTPMethod.GET)
                .controllerPath(this.basePath())
                .relativePath("zones")
                .build())
            .pipe(
                orElse<string[]>([] as string[])
            );
    }

	public areasByZoneInActiveCampaign(zoneLevelId: number): Observable<string[]> {
		return this.httpService.send<typeof undefined, string[]>(
            new HTTPRequestBuilder()
                .method(HTTPMethod.GET)
                .controllerPath(this.basePath())
                .relativePath(`activeAreas/${zoneLevelId}`)
                .build());
	}

    public basePath(): string {
        return "api/campaignLevels";
    }

	public campaignLevelByCampaignId(campaignId: number, levelTypeId: LevelTypeId): Observable<CampaignLevel[]> {
        return this.httpService.send<typeof undefined, CampaignLevel[]>(
            new HTTPRequestBuilder()
                .method(HTTPMethod.GET)
                .controllerPath(this.basePath())
                .relativePath(`?campaignId=${campaignId}&levelTypeId=${levelTypeId}`)
                .build())
            .pipe(
                orElse<CampaignLevel[]>([] as CampaignLevel[]),
				map(campaignLevels => campaignLevels
					.map(campaignLevel => CampaignLevel.from(campaignLevel))));
    }

	// Debería estar en CronService:
    public orderDebtProcessByCampaignLevel(campaignLevelId: number): Observable<any> {
        return this.httpService.send<typeof undefined, null>(
            new HTTPRequestBuilder()
                .method(HTTPMethod.GET)
                .controllerPath("api/cron")
                .relativePath(`uniqueOrderDebt/${campaignLevelId}`)
                .build());
    }
}
